import { Outlet, useLocation } from "react-router-dom";
import { AppBar, BottomTabBar } from "./components/Nav";
import { OfflineStrip } from "./components/OfflineStrip";
import { PolicyFooter } from "./components/PolicyFooter";
import { useI18n } from "./i18n";

/** โครงหน้าหลัก: AppBar/TopNav, แถบออฟไลน์, เนื้อหา, BottomTabBar (ไม่แสดงในหน้า login) */
export function AppLayout() {
  const { t } = useI18n();
  const { pathname } = useLocation();
  return (
    <>
      <a className="skip-link" href="#main">
        {t("web.skip")}
      </a>
      <AppBar />
      <OfflineStrip />
      <main className="page page-main" id="main" tabIndex={-1}>
        <div className="container">
          <Outlet />
          {pathname !== "/" && <PolicyFooter />}
        </div>
      </main>
      {pathname !== "/login" && pathname !== "/consent" && !pathname.startsWith("/checkout") && !/^\/jobs\/[^/]+\/quote$/.test(pathname) && <BottomTabBar />}
    </>
  );
}
